import React from 'react'
import { Button, Card, CardHeader, Input, Label, DropdownMenu } from '@/shared/ui'

type HeaderProps = {
  title?: string
  totalAssets: number
  displayed: number
  filter: string
  onChangeFilter: (v: string) => void
  onReload: () => void
  onOpenOverview: () => void
  onRefreshHealth: () => void
  addOpen: boolean
  onToggleAdd: () => void
  healthFilter: 'ALL' | 'OK' | 'WARN'
  onChangeHealthFilter: (v: 'ALL' | 'OK' | 'WARN') => void
  logoFilter: 'ALL' | 'WITH' | 'WITHOUT'
  onChangeLogoFilter: (v: 'ALL' | 'WITH' | 'WITHOUT') => void
  activeFilter: 'ALL' | 'ACTIVE' | 'INACTIVE'
  onChangeActiveFilter: (v: 'ALL' | 'ACTIVE' | 'INACTIVE') => void
  quoteFilter: 'ALL' | 'USDT' | 'USDC' | 'BTC'
  onChangeQuoteFilter: (v: 'ALL' | 'USDT' | 'USDC' | 'BTC') => void
}

export function ManageHeader({
  title = 'Gerenciar cripto',
  totalAssets,
  displayed,
  filter,
  onChangeFilter,
  onReload,
  onOpenOverview,
  onRefreshHealth,
  addOpen,
  onToggleAdd,
  healthFilter,
  onChangeHealthFilter,
  logoFilter,
  onChangeLogoFilter,
  activeFilter,
  onChangeActiveFilter,
  quoteFilter,
  onChangeQuoteFilter,
}: HeaderProps) {
  return (
    <Card>
      <CardHeader>
        <div className="flex flex-col gap-2">
          <div className="text-lg font-semibold">{title}</div>
          <div className="flex items-center justify-between text-sm">
            <div>Moedas cadastradas: <b>{totalAssets}</b></div>
            <div>Exibindo: <b>{displayed}</b></div>
          </div>
          <div>
            <div className="mb-1 text-xs text-foreground/70">Filtrar</div>
            <div className="flex items-center gap-2">
              <Input
                placeholder="Ex.: BTC, BTCUSDT"
                value={filter}
                onChange={(e)=> onChangeFilter(e.target.value)}
                className="h-8 sm:h-9 text-sm flex-1 min-w-0"
              />
              <Button onClick={onReload} className="h-8 sm:h-9 whitespace-nowrap shrink-0 w-auto px-3 sm:px-4">Recarregar</Button>
              <DropdownMenu
                align="end"
                trigger={<Button variant="outline" className="h-8 sm:h-9 whitespace-nowrap shrink-0 w-auto px-3 sm:px-4">Ações</Button>}
                items={[
                  { label: 'Saúde geral', onSelect: () => onOpenOverview() },
                  { label: 'Atualizar saúde', onSelect: () => onRefreshHealth() },
                  { label: addOpen ? 'Fechar' : 'Adicionar moedas', onSelect: () => onToggleAdd() },
                ]}
              />
            </div>
          </div>
          <div className="grid grid-cols-4 gap-3">
            <div>
              <Label className="text-xs">Saúde</Label>
              <select className="w-full rounded-md border border-border bg-background px-2 py-2 text-sm" value={healthFilter} onChange={(e)=> onChangeHealthFilter(e.target.value as any)}>
                <option value="ALL">Todos</option>
                <option value="OK">Ok</option>
                <option value="WARN">Com alertas</option>
              </select>
            </div>
            <div>
              <Label className="text-xs">Logo</Label>
              <select className="w-full rounded-md border border-border bg-background px-2 py-2 text-sm" value={logoFilter} onChange={(e)=> onChangeLogoFilter(e.target.value as any)}>
                <option value="ALL">Com e sem logo</option>
                <option value="WITH">Somente com logo</option>
                <option value="WITHOUT">Somente sem logo</option>
              </select>
            </div>
            <div>
              <Label className="text-xs">Coleta</Label>
              <select className="w-full rounded-md border border-border bg-background px-2 py-2 text-sm" value={activeFilter} onChange={(e)=> onChangeActiveFilter(e.target.value as any)}>
                <option value="ALL">Ativos e Inativos</option>
                <option value="ACTIVE">Somente Ativos</option>
                <option value="INACTIVE">Somente Inativos</option>
              </select>
            </div>
            <div>
              <Label className="text-xs">Paridade</Label>
              <select className="w-full rounded-md border border-border bg-background px-2 py-2 text-sm" value={quoteFilter} onChange={(e)=> onChangeQuoteFilter(e.target.value as any)}>
                <option value="ALL">Todas</option>
                <option value="USDT">USDT</option>
                <option value="USDC">USDC</option>
                <option value="BTC">BTC</option>
              </select>
            </div>
          </div>
        </div>
      </CardHeader>
    </Card>
  )
}
